export default "__VITE_ASSET__DhSCsq_l__"